import { render, staticRenderFns } from "./index.vue?vue&type=template&id=88224e90&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=88224e90&prod&lang=less&scoped=true&"
import style1 from "./index.vue?vue&type=style&index=1&id=88224e90&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88224e90",
  null
  
)

export default component.exports